<div *ngIf="!!deliveries" class="content-area">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Zu buchende Lieferscheine</h2>
  <p class="opener" cds-text="section">Diese Lieferung(en) müssen abgerechnet werden...</p><br>

  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'number'">Lieferschein</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_id'">Bestellnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'project'">Kunde/Betreff</clr-dg-column>
    <clr-dg-column [clrDgField]="'dateI'">Datum</clr-dg-column>
    <clr-dg-column>Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Delivery Note!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let delivery of deliveries">
      <clr-dg-cell [routerLink]="['/delivery/details', delivery.project_id, delivery.job_id, delivery.delivery_id]">{{ delivery.project_id }}.0004.{{ delivery.delivery_id }}</clr-dg-cell>
      <clr-dg-cell>{{ delivery.order_id}}</clr-dg-cell>
      <clr-dg-cell><b>{{ delivery.company_name }}</b><br />{{ delivery.name_project }}</clr-dg-cell>
      <clr-dg-cell>{{ delivery.delivery_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell [className]="findButtonClass(delivery.status)" role="alert">
        <div class="alert-items">
          <div class="alert-item static">
            <div class="alert-icon-wrapper">
              <cds-icon *ngIf="delivery.status === 'open'" class="alert-icon" shape="info-circle"></cds-icon>
              <cds-icon *ngIf="delivery.status === 'finished'" class="alert-icon" shape="check-circle"></cds-icon>
            </div>
            <span *ngIf="delivery.status === 'open'" class="alert-text">Offen</span>
            <span *ngIf="delivery.status === 'finished'" class="alert-success">Gebucht</span>
          </div>
        </div>
      </clr-dg-cell>
      <clr-dg-row-detail *clrIfExpanded clrLoading>
        <table class="table">
          <tbody>
          <tr>
            <td>
              <app-job-details-deliveries [jobid]="delivery.job_id ?? 0" [delprid]="delivery.project_id" [delposid]="'0'" [delpartid]="0" [deliveryID]="delivery.delivery_id ?? 0" [posList]="true"></app-job-details-deliveries>
            </td>
          </tr>
          </tbody>
        </table>
      </clr-dg-row-detail>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Lieferscheine pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von  {{ deliveries.length }} Lieferschein(en)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</div>
